import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { InlineWarning, A } from '@driftt/tide-core';

import { Icon } from '@driftt/tide-icons'

import GoogleOauth from './GoogleOauth'
import MicrosoftOauth from './MicrosoftOauth'
import './style.css'

export const CONNECT_ERRORS = Object.freeze({
  GMAIL: 'GMAIL',
  MICROSOFT: 'MICROSOFT'
})

const ConnectErrorWarning = () => {
  return <InlineWarning
    className="setup-meetings-calendars--warning"
    type="warning"
    title="Something went wrong while connecting your calendar"> 
      We recommend reading this article on <A href="https://gethelp.drift.com/hc/en-us/articles/360019448074-How-to-connect-your-calendar-to-Drift-Meetings" target="_blank">how to connect your calendar to Drift Meetings</A>, or you can reach out to support!
    </InlineWarning>
}


export const MeetingsStepWithPrime = ({ color, connectError, setConnectError, onSkipClick, isCalendarSeat, userId }) => {
  const HEADER_COPY = 'Connect your calendar'
  const SUBHEADER_COPY_COMPONENT = isCalendarSeat ?
    <p className="subtitle">Don't worry, you'll have full control over when people can book time, and we'll make sure you're never double booked.</p> :
    <p className="subtitle">Give people a direct line to your calendar so you can spend more of your time selling, and less of it scheduling</p>

  return (
    <Fragment>
      <h1>{HEADER_COPY}</h1>
      {SUBHEADER_COPY_COMPONENT}
        <Fragment>
          {connectError && <ConnectErrorWarning />}
          <div className="setup-meetings-calendars-container" >
            <GoogleOauth setConnectError={setConnectError} isCalendarSeat={false} userId={userId} />
            <MicrosoftOauth setConnectError={setConnectError} isCalendarSeat={false} userId={userId} />
          </div>
        </Fragment>
      
      {isCalendarSeat ?
        <Link 
          className="calendar-back-arrow"
          to="/setup/calendaring/profile">
          <Icon name="arrow-1-left" className="welcome-back-caret"/>
          Back
        </Link> :
        <span className="skip-for-now" onClick={onSkipClick}>
          {`Skip and connect later` }
        </span>
      }
    </Fragment>
  )
}
